import { calculatePageIndices } from '@/utils/object';
import { timeAndTimeZone } from '@/utils/datetime';
import _ from 'lodash';

export default {
	data() {
		return {
			showObjDetailsModal: false,
			objectDetails: {},
			tableSource: {}
		};
	},
	computed: {
		actionDetails() {
			if (_.isEmpty(this.logs)) {
				return '';
			}
			let name = this.logs.changedByUserName
				.split(' ')
				.map(el => el.charAt(0).toUpperCase() + el.slice(1))
				.join(' ');
			return `${this.logs.action}d by ${name} on ${timeAndTimeZone(
				this.logs.timestamp
			)}`;
		}
	},
	methods: {
		/* formatType selects the Action column format. Different for each page */
		formatActionText(body, formatType = 0) {
			if (body.action == 'Add') {
				return '<strong>Created</strong>';
			}

			if (body.fieldChanges.items) {
				const changes = body.fieldChanges.items;
				const {
					NewValue,
					OriginalValue,
					ChangedPropertyName
				} = changes[0];
				if (changes.length === 1) {
					if (!NewValue) {
						return (
							this.returnObjFormatedText(changes[0], 'delete') ||
							`<span style="color: red">Deleted</span> property <strong>${ChangedPropertyName}</strong>`
						);
					} else if (!OriginalValue) {
						return (
							this.returnObjFormatedText(changes[0], 'create') ||
							`<span style="color: blue">Added</span> property <strong>${ChangedPropertyName}</strong> with new value: <strong>${NewValue}</strong>`
						);
					} else {
						return (
							this.returnObjFormatedText(changes[0], 'update') ||
							`<strong>Updated</strong> property <strong>${ChangedPropertyName}</strong> original: <strong>${OriginalValue}</strong> switched to: <strong>${NewValue}</strong>`
						);
					}
				} else {
					if (formatType === 0) {
						return `
							<strong>Multiple Updates: </strong> ${this.getAllPropertyNames(changes)}`;
					} else if (formatType === 1) {
						return `<strong>Update </strong> property ${ChangedPropertyName}, +${changes.length -
							1} more changes`;
					}
				}
			}
		},
		removeIdPropName(obj) {
			return obj.replace(/\[[^\]]*\]/g, '');
		},
		removeAttrPropName(obj) {
			return obj.replace(/\..*/, '');
		},
		returnObjFormatedText(change, action) {
			if (
				typeof change.NewValue !== 'object' &&
				typeof change.OriginalValue !== 'object'
			) {
				return '';
			}

			const propName = change.ChangedPropertyName;

			if (action === 'delete') {
				return `<span style="color: red">Deleted</span> object <strong>${this.removeIdPropName(
					propName
				)}</strong>`;
			} else if (action === 'create') {
				return `<span style="color: blue">Added</span> new <strong>${this.removeIdPropName(
					propName
				)}</strong>`;
			} else {
				// update
				return `<strong>Updated</strong> property <strong>${this.removeIdPropName(
					propName
				)}</strong> original: <strong>${
					change.OriginalValue
				}</strong> switched to: <strong>${change.NewValue}</strong>`;
			}
		},
		getAllPropertyNames(changes) {
			let names = new Set();

			changes.forEach(change => {
				// DEV NOTE: include all the works we need to remove
				const name = this.removeIdPropName(
					this.removeAttrPropName(change.ChangedPropertyName)
				);

				names.add(name);
			});
			return Array.from(names).join(', ');
		},
		returnId(text) {
			const regex = /\[(.*?)\]/g;
			const matches = text.match(regex);

			if (matches) {
				return matches[0];
			}
			return '';
		},
		returnAttr(text) {
			if (text.indexOf('.') !== -1) {
				const matchWithAttr = text.match(/[^.]+$/);
				return matchWithAttr[0];
			}
			return '';
		},
		formatNewValue(data) {
			if (data.Action === 'Delete' && !data.NewValue) {
				return '<span style="color: red">Deleted</span>';
			} else {
				return data.NewValue;
			}
		},
		formatOriginalValue(data) {
			if (data.Action === 'Add' && !data.OriginalValue) {
				return '<span style="color: blue">Added</span>';
			} else {
				return data.OriginalValue;
			}
		},
		formatChangeByRole(data) {
			return `${data.changedByUserName} - ${data.changedByUserRole}`;
		},
		isDeleteOrCreate(data) {
			const items = _.get(data, 'fieldChanges.items', []);

			if (_.isEmpty(items) || items.length !== 1) {
				return false;
			}

			const action = _.get(items, '[0].Action');
			if (!_.includes(['Delete', 'Add'], action)) {
				return false;
			}

			const originalValue = _.get(items, '[0].OriginalValue');
			const newValue = _.get(items, '[0].NewValue');
			if (!_.isObject(originalValue) || !_.isObject(newValue)) {
				return false;
			}

			return true;
		},
		displayDetailsModal(data) {
			this.objectDetails =
				data.fieldChanges.items[0].OriginalValue ||
				data.fieldChanges.items[0].NewValue;

			this.showObjDetailsModal = true;
		},
		updatePagination({ page, pageSize }) {
			const { items, totalPages } = calculatePageIndices(
				this.formLogData.source.items,
				page,
				pageSize
			);
			const newSource = {
				countPerPage: pageSize,
				items,
				page,
				totalCount: this.formLogData.source.length,
				totalPageCount: totalPages
			};

			this.formLogData.source = newSource;
		},
		handleWindowSizeChange() {
			this.windowWidth = window.innerWidth;
		}
	}
};
